module.exports = __webpack_public_path__ + "static/media/logo.b86c5547.jpg";